<template>
  <Modal v-model="model" sticky reset-drag-position title="会话处理" @on-cancel="cancel" footer-hide :mask="false" draggable >
    <div>
      <div class="div_class">
        <div class="span_left">访客名称:</div>
        <el-input type="text"  placeholder=""  size="large"  style="width: 70%"  :readonly="readonly" v-model="reName"></el-input>
      </div>
      <div class="div_class">
        <div  class="span_left"><span style="color:red">*</span>访客号码:</div>
        <el-input type="text" size="large"  style="width: 70%"  :readonly="readonly" v-model="rePhone"></el-input>
      </div>
      <div class="div_class">
        <div  class="span_left">访客公司:</div>
        <el-input type="text"  placeholder=""  size="large" style="width: 70%" :readonly="readonly" v-model="reCompany"></el-input>
      </div>
      <div class="div_class">
        <div  class="span_left">访客邮箱:</div>
        <el-input type="email" placeholder=""  size="large"  style="width: 70%" :readonly="readonly" v-model="reEmail"></el-input>
      </div>
      <div class="div_class">
        <div  class="span_left"><span style="color:red">*</span>访客留言:</div>
        <el-input type="textarea" rows="3" placeholder=""  size="large" style="width:70%;" :readonly="readonly" v-model="reContent"></el-input>
      </div>
      <div class="div_class">
        <div  class="span_left">备&#12288;&#12288;注:</div>
        <Input type="textarea" :rows="3" placeholder="请输入备注" style="width:70%;" autosize size="large" v-model="remarks" :maxlength="250"></Input>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "RemarksPop",
      mixins:[publicFunClass],
      props: {
        showRemarksPop:Boolean,
        reIds:String,
        reName:String,
        rePhone:String,
        reCompany:String,
        reEmail:String,
        reContent:String,
      },
      data(){
        return {
          model:false,
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          journalType:'统计报表=>明细报表=>会话留言=>处理',
          menuId:'8_2-10-5',
          remarks:'',
          readonly:true,
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeRemarksPop",false);
        },
        save:function(){
          let that=this;
          if(!this.remarks){
            that.$Modal.info({
              title:'提示',
              content:"备注不能为空"
            });
            return false;
          }
          let param= {
            journalType:this.journalType,
            menuId:this.menuId,
            ids:this.reIds,
            type:'0',
            callRemark:this.remarks
          }
          this.$http.post('chatLeave/doDealLeaveMsg.json',param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info(res.data.msg);
            that.$emit("closeRemarksPop",true);
          });
        },
      },
      created() {
          this.remarks="已回访";
      },
      watch:{
        showRemarksPop:function () {
          this.model=this.showRemarksPop;
          if(this.showRemarksPop){
          }
        }
      }
    }
</script>

<style scoped>
  .div_class{
    display:flex;
    margin-bottom:10px;
    justify-content:center;
  }
  .span_left{
    margin-right:10px;
    width: 15%;
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/RemarksPop.vue